var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedcar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4390_37",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4390_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00098 30C7.75098 30 6.68848 29.5625 5.81348 28.6875C4.93848 27.8125 4.50098 26.75 4.50098 25.5H1.50098V9C1.50098 8.175 1.79473 7.46875 2.38223 6.88125C2.96973 6.29375 3.67598 6 4.50098 6H25.501V12H30.001L34.501 18V25.5H31.501C31.501 26.75 31.0635 27.8125 30.1885 28.6875C29.3135 29.5625 28.251 30 27.001 30C25.751 30 24.6885 29.5625 23.8135 28.6875C22.9385 27.8125 22.501 26.75 22.501 25.5H13.501C13.501 26.75 13.0635 27.8125 12.1885 28.6875C11.3135 29.5625 10.251 30 9.00098 30ZM9.00098 27C9.42598 27 9.78223 26.8563 10.0697 26.5688C10.3572 26.2813 10.501 25.925 10.501 25.5C10.501 25.075 10.3572 24.7188 10.0697 24.4313C9.78223 24.1438 9.42598 24 9.00098 24C8.57598 24 8.21973 24.1438 7.93223 24.4313C7.64473 24.7188 7.50098 25.075 7.50098 25.5C7.50098 25.925 7.64473 26.2813 7.93223 26.5688C8.21973 26.8563 8.57598 27 9.00098 27ZM4.50098 22.5H5.70098C6.12598 22.05 6.61348 21.6875 7.16348 21.4125C7.71348 21.1375 8.32598 21 9.00098 21C9.67598 21 10.2885 21.1375 10.8385 21.4125C11.3885 21.6875 11.876 22.05 12.301 22.5H22.501V9H4.50098V22.5ZM27.001 27C27.426 27 27.7822 26.8563 28.0697 26.5688C28.3572 26.2813 28.501 25.925 28.501 25.5C28.501 25.075 28.3572 24.7188 28.0697 24.4313C27.7822 24.1438 27.426 24 27.001 24C26.576 24 26.2197 24.1438 25.9322 24.4313C25.6447 24.7188 25.501 25.075 25.501 25.5C25.501 25.925 25.6447 26.2813 25.9322 26.5688C26.2197 26.8563 26.576 27 27.001 27ZM25.501 19.5H31.876L28.501 15H25.501V19.5Z",
    fill: "#C10606"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedcar);
export default __webpack_public_path__ + "static/media/redcar.09b1ed01817fac06d24d22b975278ffc.svg";
export { ForwardRef as ReactComponent };